import {Add, DeleteOutlineOutlined} from '@mui/icons-material'
import {Box, Button, Grid, Typography} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {AssignedUser} from '../../types'
import {FieldErrors} from '../../validation'

import {ResponsibleUserSearch} from './ResponsibleUserSearch'

type ResponsiblePersonsProps = {
  translationPrefix?: string
  assignedUsers: AssignedUser[]
  setAssignedUsers: React.Dispatch<React.SetStateAction<AssignedUser[]>>
  errors: FieldErrors
  setIsDirty: React.Dispatch<React.SetStateAction<boolean>>
}

export const ResponsiblePersons: React.FC<ResponsiblePersonsProps> = ({
  assignedUsers,
  setAssignedUsers,
  errors,
  setIsDirty
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  const handleAddClick = () => {
    setAssignedUsers((prev) => {
      return [...prev, {userId: '', name: '', id: crypto.randomUUID()}]
    })
    setIsDirty(true)
  }

  const handleDeleteClick = (id: string) => {
    setAssignedUsers((prev) => {
      return prev.filter((user) => user.id !== id)
    })
    setIsDirty(true)
  }

  return (
    <Box data-test-id="responsible-person-selection">
      <Grid display="flex" marginBottom={1} justifyContent="space-between">
        <Typography variant="h4">{t('responsiblePersonDialog.label.responsible')}</Typography>
        <Button
          onClick={handleAddClick}
          data-test-id="add-responsible-person-button"
          variant="text"
          startIcon={<Add />}
        >
          {t('responsiblePersonDialog.action.add')}
        </Button>
      </Grid>
      {!assignedUsers.length && (
        <Typography variant="subtitle1" color="GrayText">
          {t('responsiblePersonDialog.label.noResponsiblePerson')}
        </Typography>
      )}
      <Grid display="flex" flexDirection="column" gap={2}>
        {assignedUsers.map((assigned, index) => (
          <Grid container key={assigned.id} gap={1} alignItems="center">
            <Grid item xs={11}>
              <ResponsibleUserSearch
                setAssignedUsers={setAssignedUsers}
                assignedUser={assigned}
                index={index}
                errors={errors}
              />
            </Grid>
            <Grid item xs={0.5}>
              <Button
                variant="text"
                data-test-id="delete-responsible-person"
                onClick={() => handleDeleteClick(assigned.id)}
              >
                <DeleteOutlineOutlined color="error" />
              </Button>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}
